import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=fea426c4&scoped=true"
import script from "./ProductService.vue?vue&type=script&lang=js"
export * from "./ProductService.vue?vue&type=script&lang=js"
import style0 from "./ProductService.vue?vue&type=style&index=0&id=fea426c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea426c4",
  null
  
)

export default component.exports